export default "__VITE_ASSET__7ff97942__"